define('plugins/musicfavourite/nls/music_guide/button',{
    'en-gb': {
        'standard': {
            'addToFavourites'       : 'Follow this playlist',
            'adding'                : 'Following this playlist',
            'addedToFavourites'     : 'Following this playlist',
            'removeFromFavourites'  : 'Unfollow this playlist',
            'removeFromFavouritesFullText' : 'Unfollow this playlist',
            'removing'              : 'Unfollowing this playlist'
        },
        'medium': {
            'addToFavourites'       : 'Follow',
            'adding'                : 'Following',
            'addedToFavourites'     : 'Following',
            'removeFromFavourites'  : 'Unfollow',
            'removing'              : 'Unfollowing'
        }
    },
    'cy-gb': { //WELSH
        'standard': {
            'addToFavourites'       : 'Dilyn y rhestr chwarae',
            'adding'                : '{{title}} Yn dilyn y rhestr chwarae',
            'addedToFavourites'     : '{{title}} Yn dilyn y rhestr chwarae',
            'removeFromFavourites'  : 'Peidio dilyn',
            'removeFromFavouritesFullText' : 'Peidio &acirc; dilyn y rhestr chwarae',
            'removing'              : 'Peidio dilyn'
        },
        'medium': {
            'addToFavourites'       : 'Dilyn',
            'adding'                : 'Yn dilyn',
            'addedToFavourites'     : 'Yn dilyn',
            'removeFromFavourites'  : 'Peidio dilyn',
            'removing'              : 'Peidio dilyn'
        }
    },
    'ga-gb': { //IRISH
        'standard': {
            'addToFavourites'       : 'Lean an seinnliosta seo',
            'adding'                : '{{title}} An seinnliosta seo leanta',
            'addedToFavourites'     : '{{title}} An seinnliosta seo leanta',
            'removeFromFavourites'  : 'Bain',
            'removeFromFavouritesFullText' : 'Stop de bheith ag lean&uacute;int',
            'removing'              : 'Ag baint'
        },
        'medium': {
            'addToFavourites'       : 'Lean',
            'adding'                : 'Ag lean&uacute;int',
            'addedToFavourites'     : 'Ag lean&uacute;int',
            'removeFromFavourites'  : 'Bain',
            'removing'              : 'Ag baint'
        }
    },
    'gd-gb': { //SCOTTISH
        'standard': {
            'addToFavourites'       : 'Lean an cl&agrave;r-ci&ugrave;il',
            'adding'                : '{{title}} Lean mi an cl&agrave;r-ci&ugrave;il seo',
            'addedToFavourites'     : '{{title}} Lean mi an cl&agrave;r-ci&ugrave;il seo',
            'removeFromFavourites'  : 'Dubh &agrave;s',
            'removeFromFavouritesFullText' : 'Dubh &agrave;s an cl&agrave;r-ci&ugrave;il seo',
            'removing'              : 'A\' dubhadh &agrave;s'
        },
        'medium': {
            'addToFavourites'       : 'Lean',
            'adding'                : 'A\' leantainn',
            'addedToFavourites'     : 'A\' leantainn',
            'removeFromFavourites'  : 'Dubh &agrave;s',
            'removing'              : 'A\' dubhadh &agrave;s'
        }
    }
});

